import React from 'react';
import { Dimensions, Platform, StatusBar } from 'react-native'

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';

import EditPayment from '../Containers/EditPayment';

const EditPaymentScreen = ({ title, onClose, onBack, ...props }) => {
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen
        onClose={onClose}
        onBack={onBack}
        withStatusBar={false}
        showBack
        title={title}
        contentContainerStyle={{ paddingHorizontal: '10%' }}
      >
        <StatusBar translucent={false} backgroundColor={'transparent'} />
        <EditPayment withTray {...props} />
      </VFScreen>
    )
  }
  return (
    <VFScreen onClose={onClose} onBack={onBack} withStatusBar={false} showBack title={title}>
      <StatusBar translucent={false} backgroundColor={'transparent'} />
      <EditPayment withTray {...props} />
    </VFScreen>
  );
};
EditPaymentScreen.defaultProps = {
  cardData: {},
};
EditPaymentScreen.propTypes = {
  title: PropTypes.string,
  cardData: PropTypes.object,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
};
export default EditPaymentScreen;
